import {useEffect, useState} from "react";
import {Order} from "../types/domain/order";
import {getOrderById} from "../services/orderService";
import {swallowException} from "../utils/appUtils";

export const useOrderById = ({companyId, orderId}: {companyId: string | null; orderId: string | null}) => {
    const [item, setItem] = useState<Order | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let ignore = false;

        if (companyId && orderId) {
            setIsLoading(true);
            getOrderById(companyId, orderId)
                .then((order) => {
                    if (!ignore) {
                        setIsLoading(false);
                        setItem(order);
                    }
                })
                .catch(swallowException);
        }
        return () => {
            ignore = true;
        };
    }, [companyId, orderId]);

    return {item, isLoading};
};
